import {Edge} from 'reactflow';

import {ProcessFlowchartForValidation} from 'processes/graph-builder-processes/validation/ProcessFlowchartForValidationTypes';
import {ProcessFlowchartEdgeType} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/processFlowchartConfigEditorConstants';

import {AdjacencyMap} from './GraphUtilConstants';

/**
 * Returns the adjacency map for a process flowchart.
 * This map traverses only control flow edges and includes all nodes even if they are unconnected.
 */
export function getAdjacencyMapFromProcessFlowchart(flowchart: ProcessFlowchartForValidation): AdjacencyMap {
  const adjacencyMap: AdjacencyMap = {};
  for (const node of flowchart.nodes) {
    adjacencyMap[node.id] = [];
  }
  return {...adjacencyMap, ...getFlowchartAdjacencyMapFromEdges(flowchart.edges)};
}

/**
 * Returns the adjacency map for a list of edges.
 * This map includes only the nodes that are connected by control flow edges.
 */
export function getFlowchartAdjacencyMapFromEdges(edges: Array<Edge>): AdjacencyMap {
  const adjacencyMap: AdjacencyMap = {};
  for (const edge of extractControlFlowEdges(edges)) {
    if (adjacencyMap[edge.source] == null) {
      adjacencyMap[edge.source] = [];
    }
    adjacencyMap[edge.source].push(edge.target);
    if (adjacencyMap[edge.target] == null) {
      adjacencyMap[edge.target] = [];
    }
  }
  return adjacencyMap;
}

/**
 * Returns the list of control flow edges from a list of edges.
 *
 * When the edge does not have a specificied type, as is the case for the vertical flowchart editor, we assume
 * it is a control flow edge.
 *
 * @param edges The list of edges to extract control flow edges from.
 * @returns The list of control flow edges.
 */
export function extractControlFlowEdges(edges: Array<Edge>): Array<Edge> {
  return edges.filter((edge) => edge.type == null || edge.type === ProcessFlowchartEdgeType.CONTROL_FLOW);
}
